import { render, staticRenderFns } from "./ActivityTable.vue?vue&type=template&id=c80dfb68&scoped=true"
import script from "./ActivityTable.vue?vue&type=script&lang=js"
export * from "./ActivityTable.vue?vue&type=script&lang=js"
import style0 from "./ActivityTable.vue?vue&type=style&index=0&id=c80dfb68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80dfb68",
  null
  
)

export default component.exports